import {
  InterBold,
  InterMedium,
  InterRegular,
  InterSemiBold,
} from '@dermloop/ui/util';
import { createGlobalStyle } from 'styled-components';

import InterExtraBold from './inter-extrabold.ttf';
import InterLight from './inter-light.ttf';
import InterLightItalic from './inter-light-italic.ttf';

// Every weight and style the type scale uses needs a face here, or the browser
// silently substitutes the nearest one: `text-h1` is ExtraBold (800) and
// `text-blockquote` is Light Italic (300). The three web-only faces live in
// this lib rather than `@dermloop/ui/util`, which the native apps bundle.
export const CustomFonts = createGlobalStyle`
    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 300;
      src: url(${InterLight});
    }

    @font-face {
      font-family: 'Inter';
      font-style: italic;
      font-weight: 300;
      src: url(${InterLightItalic});
    }

    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      src: url(${InterRegular});
    }

    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      src: url(${InterMedium});
    }

    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 600;
      src: url(${InterSemiBold});
    }

    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      src: url(${InterBold});
    }

    @font-face {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 800;
      src: url(${InterExtraBold});
    }
`;
